import React, { useEffect } from "react";
import {
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  COLOURBOND_COLORS,
  PLATINUM_COLORS,
  NATIVE_COLORS,
  COMPOSITE_COLORS,
} from "../Constants/constants";

const ColorSelector = ({
  selectSeries,
  selectedDesign,
  selectedPanelStyle,
  selectedColor,
  setSelectedColor,
  setColorName,
  selectedRect,
  applyDoorDesign,
  selectedPattern,
}) => {
  const onColorChange = (e) => {
    const color = e.target.value;
    let colorList = [];

    if (selectSeries === "Native") {
      colorList = NATIVE_COLORS;
    } else if (
      selectSeries === "Selections Series" &&
      selectedPanelStyle !== "SolidSheet"
    ) {
      colorList = COMPOSITE_COLORS;
    } else if (
      selectSeries === "Essentials" && (selectedDesign === "Madison" ||
       selectedDesign === "Tuscan")
    ) {
      colorList = [...PLATINUM_COLORS, ...COLOURBOND_COLORS];
    } else {
      colorList = COLOURBOND_COLORS;
    }

    const selected = colorList.find((c) => c.bgcolor === color);
    if (selected) {
      setColorName(selected.name);
      setSelectedColor(color);

      if (selectedRect) {
        applyDoorDesign(color, selectedPattern);
      }
    }
  };

  useEffect(() => {
    let defaultColor = "#5e1d0e";
    let colorGroup = COLOURBOND_COLORS;

    // Override if Native
    if (selectSeries === "Native") {
      defaultColor = "#632b0a";
      colorGroup = NATIVE_COLORS;
    }

    // Override if Selections Series and not SolidSheet
    else if (
      selectSeries === "Selections Series" &&
      selectedPanelStyle !== "SolidSheet"
    ) {
      defaultColor = "#aaaaaa";
      colorGroup = COMPOSITE_COLORS;
    }

    // Override if Platinum applicable (Madison/Tuscan design for Essentials)
    else if (
      (selectedDesign === "Madison" || selectedDesign === "Tuscan") &&
      selectSeries === "Essentials"
    ) {
      defaultColor = "#3f3f3b";
      colorGroup = [...PLATINUM_COLORS, ...COLOURBOND_COLORS];
    }

    // Check if current selected color exists in the new color group
    const currentColorExists = colorGroup.find((c) => c.bgcolor === selectedColor);
    
    // If current color doesn't exist in new palette, reset to default
    if (!currentColorExists) {
      const defaultColorObj = colorGroup.find((c) => c.bgcolor === defaultColor);
      
      if (defaultColorObj) {
        setSelectedColor(defaultColor);
        setColorName(defaultColorObj.name);
        if (selectedRect) applyDoorDesign(defaultColor, selectedPattern);
      }
    }
  }, [
    selectSeries,
    selectedPanelStyle,
    selectedDesign,
    selectedPattern,
    selectedRect,
  ]);

  const ColorLabel = ({ name, color, trademark }) => (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box
        sx={{
          width: 20,
          height: 20,
          backgroundColor: color,
          border: "1px solid #ccc",
          marginRight: 1,
        }}
      />
      <Typography variant="body2">
        {name}
        {trademark && (
          <sup style={{ fontSize: "0.7em", marginLeft: "2px" }}>
            {trademark}
          </sup>
        )}
      </Typography>
    </Box>
  );

  return (
    <>
      {selectSeries !== "Native" && selectedPanelStyle !== "Alumicomp" && (
        <>
          <section className="customisingdesktopDoor mt-4 mb-4">
            <h5 className="mt-3">Select Your Door Colour</h5>
            <h6>
              COLORBOND
              <sup
                style={{ fontSize: "17px", fontWeight: "600", top: "-0.3em" }}
              >
                ®
              </sup>{" "}
            </h6>
            <div className="d-flex align-items-center flex-wrap">
              <div className="selected mb-3 d-flex align-items-center">
                <FormControl fullWidth>
                  <InputLabel id="colorbond-label">Select a Colour</InputLabel>
                  <Select
                    labelId="colorbond-label"
                    value={selectedColor}
                    label="Colorbond"
                    name="colorbond"
                    onChange={onColorChange}
                  >
                    {COLOURBOND_COLORS.map((option) => (
                      <MenuItem key={option.id} value={option.bgcolor}>
                        <ColorLabel
                          name={option.name}
                          trademark={option.trademark}
                          color={option.bgcolor}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </section>
        </>
      )}

      {selectSeries === "Native" && (
        <>
          <section className="customisingdesktopDoor mt-4 mb-4">
            <h5 className="mt-3">Select Your Door Colour</h5>
            <h6>Native Series</h6>
            <div className="d-flex align-items-center flex-wrap">
              <div className="selected mb-3 d-flex align-items-center">
                <FormControl fullWidth>
                  <InputLabel id="native-label">Select a Colour</InputLabel>
                  <Select
                    labelId="native-label"
                    value={selectedColor}
                    label="Native"
                    name="native"
                    onChange={onColorChange}
                  >
                    {NATIVE_COLORS.map((option) => (
                      <MenuItem key={option.id} value={option.bgcolor}>
                        <ColorLabel
                          name={option.name}
                          trademark=""
                          color={option.bgcolor}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </section>
        </>
      )}

      {selectSeries === "Selections Series" &&
        selectedPanelStyle !== "SolidSheet" && (
          <>
            <section className="customisingdesktopDoor mt-4 mb-4">
              <h5 className="mt-3">Select Your Material Colour</h5>
              <h6>Composite</h6>
              <div className="d-flex align-items-center flex-wrap">
                <div className="selected mb-3 d-flex align-items-center">
                  <FormControl fullWidth>
                    <InputLabel id="composite-label">Select a Colour</InputLabel>
                    <Select
                      labelId="composite-label"
                      value={selectedColor}
                      label="Composite"
                      name="composite"
                      onChange={onColorChange}
                    >
                      {COMPOSITE_COLORS.map((option) => (
                        <MenuItem key={option.id} value={option.bgcolor}>
                          <ColorLabel
                            name={option.name}
                            trademark=""
                            color={option.bgcolor}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </section>
          </>
        )}

      {selectSeries === "Essentials" &&
        selectedPattern !== "roller" &&
        (selectedDesign === "Madison" || selectedDesign === "Tuscan") && (
          <>
            <section className="customisingdesktopDoor mt-4 mb-4">
              <h6>Platinum</h6>
              <div className="d-flex align-items-center flex-wrap">
                <div className="selected mb-3 d-flex align-items-center">
                  <FormControl fullWidth>
                    <InputLabel id="platinum-label">Select a Colour</InputLabel>
                    <Select
                      labelId="platinum-label"
                      value={selectedColor}
                      label="Platinum"
                      name="platinum"
                      onChange={onColorChange}
                    >
                      {PLATINUM_COLORS.map((option) => (
                        <MenuItem key={option.id} value={option.bgcolor}>
                          <ColorLabel
                            name={option.name}
                            trademark=""
                            color={option.bgcolor}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </section>
          </>
        )}
    </>
  );
};

export default ColorSelector;
